const TRAINING_START_WORKOUT_DOMAIN = 'startWorkout'

const TRAINING_START_WORKOUT_ACTION = {
  SET_CURRENT_WORKOUT_EXERCISE: 'SET_CURRENT_WORKOUT_EXERCISE',
  SET_CURRENT_WORKOUT_SECTION: 'SET_CURRENT_WORKOUT_SECTION',
  SET_HAS_PAUSED: 'SET_HAS_PAUSED',
  SET_HAS_STARTED: 'SET_HAS_STARTED'
}

const TRAINING_START_WORKOUT_KEY = {
  CURRENT_WORKOUT_EXERCISE_INDEX: 'currentWorkoutExerciseIndex',
  CURRENT_WORKOUT_SECTION_INDEX: 'currentWorkoutSectionIndex',
  HAS_PAUSED: 'hasPaused',
  HAS_STARTED: 'hasStarted'
}

export {
  TRAINING_START_WORKOUT_DOMAIN,
  TRAINING_START_WORKOUT_ACTION,
  TRAINING_START_WORKOUT_KEY
}
